<div class="container-plan" [ngClass]="{'extra-margin-top': !is_from_ad}">

    <div class="container-email-validated" *ngIf="is_from_validate_email">
        <div class="container-email-validated-content" *ngIf="!error_validation">
            <img src="assets/verified-mail-check.png" alt="Email validado">
            <span>{{ 'common.messages.emailValidated' | translate }}</span>
        </div>
        <div class="container-email-validated-content" *ngIf="error_validation">
            <span style="color: red;">{{ 'common.messages.invalidToken' | translate }}</span>
        </div>
        <div class="container-email-validated-actions">
            <button (click)="is_from_validate_email = false">
                <img class="close-icon" src="assets/boton-x.png" alt="Comprar más licencias">
            </button>
        </div>
    </div>

    <h2>{{additional_licenses ? ('compassBuy.title.buyMoreLicenses' | translate) : ('compassBuy.title.selectPlan' | translate)}}</h2>

    <div class="plan-container">
        <div class="plan-container-title">
            <h3>{{additional_licenses ? ('compassBuy.subtitle.additionalLicenses' | translate) : ('compassBuy.subtitle.configureSubscription' | translate)}}</h3>
        </div>
        <div class="plan-container-content">
            <div class="select-users-container">
                <div class="select-users-title">
                    <p>{{ 'common.labels.numberOfUsers' | translate }} <br> {{ 'compassBuy.users' | translate }}</p>
                </div>
                <div class="select-users-content">
                    <input type="number" [placeholder]="'common.labels.quantity' | translate" [(ngModel)]="quantity" min="1" max="10" (input)="onQuantityChange($event)">
                </div>
            </div>
            <div class="plan-card-container">
                <div class="plan-card">
                    <h2>{{ 'compassBuy.plans.monthly.title' | translate }}</h2> 
                    <p class="plan-card-total-price">{{monthlyTotalPrice | number:'1.2-2'}}€ <span>{{ 'compassBuy.plans.monthly.totalPrice' | translate }}</span></p>
                    <p class="plan-card-price">
                        <span class="span-price-offer" *ngIf="is_offer">{{250 * quantity | number:'1.'}}€</span>
                        <span>{{monthlyPricePerUser * quantity | number:'1.2-2'}}€</span>
                        <span class="span-price">EUR <br> /mes</span>
                    </p>
                    <p class="plan-card-price-description">{{ 'compassBuy.plans.monthly.priceDescription' | translate }}</p>
                    <div class="divider"></div>
                    <p class="plan-card-caracteristics-title">{{ 'compassBuy.plans.features.title' | translate }}</p>
                    <div class="plan-card-caracteristics-list">
                        <div class="plan-card-caracteristics-list-item">
                            <img src="assets/check-black.png" alt="Check">
                            <span>{{ 'compassBuy.plans.features.unlimitedUse' | translate }}</span>
                        </div>
                        <div class="plan-card-caracteristics-list-item">
                            <img src="assets/check-black.png" alt="Check">
                            <span>{{ 'compassBuy.plans.features.assistant247' | translate }}</span>
                        </div>
                        <div class="plan-card-caracteristics-list-item">
                            <img src="assets/check-black.png" alt="Check">
                            <span>{{ 'compassBuy.plans.features.guarantee' | translate }}</span>
                        </div>
                    </div>
                    <div class="plan-card-button-container">
                        <button mat-button class="plan-card-button" (click)="buyCompass('mensual')"><span>{{ (is_offer ? 'common.buttons.tryFreeOffer' : 'common.buttons.tryFree') | translate }}</span></button>
                    </div>
                </div>

                <div class="plan-card" *ngIf="!is_offer">
                    <h2>{{ 'compassBuy.plans.annual.title' | translate }}</h2> 
                    <p class="plan-card-total-price">{{2280 * quantity | number:'1.'}}€ <span>{{ 'compassBuy.plans.annual.totalPrice' | translate }}</span></p>
                    <p class="plan-card-price">
                        <span class="span-price-offer">{{250 * quantity | number:'1.'}}€</span>
                        <span>{{190 * quantity | number:'1.'}}€</span>
                        <span class="span-price">EUR <br> /mes</span>
                    </p>
                    <p class="plan-card-price-description">{{ 'compassBuy.plans.annual.priceDescription' | translate }}</p>
                    <div class="divider"></div>
                    <p class="plan-card-caracteristics-title">{{ 'compassBuy.plans.features.title' | translate }}</p>
                    <div class="plan-card-caracteristics-list">
                        <div class="plan-card-caracteristics-list-item">
                            <img src="assets/check-black.png" alt="Check">
                            <span>{{ 'compassBuy.plans.features.unlimitedUse' | translate }}</span>
                        </div>
                        <div class="plan-card-caracteristics-list-item">
                            <img src="assets/check-black.png" alt="Check">
                            <span>{{ 'compassBuy.plans.features.assistant247' | translate }}</span>
                        </div>
                        <div class="plan-card-caracteristics-list-item">
                            <img src="assets/check-black.png" alt="Check">
                            <span>{{ 'compassBuy.plans.features.guarantee' | translate }}</span>
                        </div>
                    </div>
                    <div class="plan-card-button-container">
                        <button mat-button class="plan-card-button" (click)="buyCompass('anual')"><span>{{ 'common.buttons.tryFree' | translate }}</span></button>
                    </div>
                </div>
            </div>

            
        </div>
    </div>
</div>
